const productGalleryFrame = {
  "framed_print_no_mat":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white_horizontal_with_shadow.png?v=1703142596",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black_horizontal_with_shadow.png?v=1703142597",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple_horizontal_with_shadow.png?v=1703142599",
    "Walnut":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/walnut_horizontal_with_shadow.png?v=1703142598",
    "Bleached Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/bleached_maple_horizontal_with_shadow.png?v=1703142598"
  },
  "framed_print_mat":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_white_horizontal_with_shadow.png?v=1703142679",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_black_horizontal_with_shadow.png?v=1703142680",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_maple_horizontal_with_shadow.png?v=1703142680",
    "Walnut":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_walnut_horizontal_with_shadow.png?v=1703142681",
    "Bleached Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_bleached_maple_horizontal_with_shadow.png?v=1703142680"
  },
  "framed_canvas":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white_float_horizontal.png?v=1703143501",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black_float_horizontal.png?v=1703143501",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple_float_horizontal.png?v=1703143501",
  },  
}  

const productGalleryFrameVt = {
  "framed_print_no_mat":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white_vertical_with_shadow.png?v=1703156027",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black_vertical_with_shadow.png?v=1703156028",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple_vertical_with_shadow.png?v=1703156028",
    "Walnut":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/walnut_vertical_with_shadow.png?v=1703156028",
    "Bleached Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/bleached_maple_vertical_with_shadow.png?v=1703156027"
  },
  "framed_print_mat":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_white_vertical_with_shadow.png?v=1703156122",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_black_vertical_with_shadow.png?v=1703156123",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_maple_vertical_with_shadow.png?v=1703156123",
    "Walnut":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_walnut_vertical_with_shadow.png?v=1703156123",
    "Bleached Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/matted_bleached_maple_vertical_with_shadow.png?v=1703156123"
  },
  "framed_canvas":{
    "White":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white_float_vertical.png?v=1703156205",
    "Black":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black_float_vertical.png?v=1703156205",
    "Maple":"https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple_float_vertical.png?v=1703156205",
  },  
} 

optionInit();



function optionInit(){

  var hasOpt = $(".variant-picker__option:nth-child(1) .variant-picker__option-info legend").text();

  hasOpt = hasOpt.toLowerCase();

  if(hasOpt.indexOf("material") != -1)
  {
    $(".variant-picker__option:nth-child(3)").hide();
  
    var mat_opt = `<fieldset class="variant-picker__option v-stack gap-2 no-js:hidden mat-option" style="display: none;">
          <div class="variant-picker__option-info h-stack justify-between gap-2">
            <div class="h-stack gap-1">
              <legend>Mat Option:</legend>
              <variant-option-value class="custom-mat-select"  for="option4">No Mat</variant-option-value>
            </div>
          </div>
          <div data-option-selector="" class="variant-picker__option-values h-stack gap-2.5 wrap">
            <input class="sr-only" type="radio" name="option4" id="swatch-1-template-option4-no-mat" value="No Mat" checked="checked" disabled>
            <label class="thumbnail-swatch rounded-swatch" for="swatch-1-template-option4-no-mat" data-option-value="">
              <div class="nomat-images">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white-no-mat.png?v=1713251823" class="mat-white">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black-nomat.png?v=1713251825" class="mat-black" style="display:none;">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple-nomat.png?v=1713251826" class="mat-maple" style="display:none;">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/walnut-nomat.png?v=1713251827" class="mat-walnut" style="display:none;">
              </div>
              <span class="mat-label">No Mat</span>
            </label>
            <input class="sr-only" type="radio" name="option4" id="swatch-2-template-option4-mat" value="Mat" disabled>
            <label class="thumbnail-swatch rounded-swatch" for="swatch-2-template-option4-mat" data-option-value="">
              <div class="nomat-images">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/white-mat.png?v=1713251824" class="mat-white">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/black-mat.png?v=1713251825" class="mat-black" style="display:none;">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/maple-mat.png?v=1713251826" class="mat-maple" style="display:none;">
                <img src="https://cdn.shopify.com/s/files/1/0309/0549/9787/files/walnut-mat.png?v=1713251827" class="mat-walnut" style="display:none;">
              </div>
              <span class="mat-label">Mat</span>
            </label>
          </div>
        </fieldset>
        `;
    var lineItems = `<input type="hidden" name="properties[Material]" value="" class="material" style="display:none;">
          <input type="hidden" name="properties[Size (WxH)]" value="" class="size" style="display:none;">
          <input type="hidden" name="properties[Wood Frame]" value="" class="frame" style="display:none;">
          <input type="hidden" name="properties[Mat Option]" value="" class="mat" style="display:none;" disabled>`;
  
    $(".variant-picker").append(mat_opt);
    $(".main-product-form").append(lineItems);
  
    var optVl = $(".variant-picker__option-values [name='option1']:checked").val();
    optionSelect(optVl);
  
    var opt1 = $(".variant-picker__option-values [name='option1']:checked").val();
    var opt2 = $(".variant-picker__option-values [name='option2']:checked").val();
    var opt3 = $(".variant-picker__option-values [name='option3']:checked").val();
    var opt4 = $(".variant-picker__option-values [name='option4']:checked").val();
  
    $(".material").val(opt1);
    $(".size").val(opt2);
    $(".frame").val(opt3);
    $(".mat").val(opt4);
  
    $(".custom-mat-select").text(opt4);
  
    var mat = opt3.toLowerCase();
    $(".mat-"+mat).show().siblings("img").hide();
  
    let isVertical = $("product-gallery").attr("data-vertical");
  
    var szVal = opt2;
    if($(".framed_print_no_mat").length != 0)
    {
      if(isVertical == 'true')
      {
        szVal = themeVariables.strings.product_total_vsize.framed_print_no_mat[szVal];
      }
      else
      {
        szVal = themeVariables.strings.product_total_size.framed_print_no_mat[szVal];
      }
    }
    else if($(".framed_print_mat").length != 0)
    {
      if(isVertical == 'true')
      {
        szVal = themeVariables.strings.product_total_vsize.framed_print_mat[szVal];
      }
      else
      {
        szVal = themeVariables.strings.product_total_size.framed_print_mat[szVal];
      }
    }
    else if($(".framed_canvas").length != 0)
    {
      if(isVertical == 'true')
      {
        szVal = themeVariables.strings.product_total_vsize.framed_canvas[szVal];
      }
      else
      {
        szVal = themeVariables.strings.product_total_size.framed_canvas[szVal];
      }
    }
  
    szVal = szVal.split("x");
    $(".product-size-outer-width").text(parseFloat(szVal[0]).toFixed(2));
    $(".product-size-outer-height").text(parseFloat(szVal[1]).toFixed(2));
    $(".con-limit-print").show();
  
    $(".variant-picker__option-values").find("input").on("change",function(){
      var opt1 = $(".variant-picker__option-values [name='option1']:checked").val();
      var opt2 = $(".variant-picker__option-values [name='option2']:checked").val();
      var opt3 = $(".variant-picker__option-values [name='option3']:checked").val();
      var opt4 = $(".variant-picker__option-values [name='option4']:checked").val();
      
      $(".material").val(opt1);
      $(".size").val(opt2);
      $(".frame").val(opt3);
      $(".mat").val(opt4);
  
      $(".custom-mat-select").text(opt4);
  
      var szVal = opt2;
      setTimeout(function(){
        console.log(szVal);
        if($(".framed_print_no_mat").length != 0)
        {
          if(isVertical == 'true')
          {
            szVal = themeVariables.strings.product_total_vsize.framed_print_no_mat[szVal];
          }
          else
          {
            szVal = themeVariables.strings.product_total_size.framed_print_no_mat[szVal];
          }
        }
        else if($(".framed_print_mat").length != 0)
        {
          if(isVertical == 'true')
          {
            szVal = themeVariables.strings.product_total_vsize.framed_print_mat[szVal];
          }
          else
          {
            szVal = themeVariables.strings.product_total_size.framed_print_mat[szVal];
          }
        }
        else if($(".framed_canvas").length != 0)
        {
          if(isVertical == 'true')
          {
            szVal = themeVariables.strings.product_total_vsize.framed_canvas[szVal];
          }
          else
          {
            szVal = themeVariables.strings.product_total_size.framed_canvas[szVal];
          }
        }
    
        szVal = szVal.split("x");
        $(".product-size-outer-width").text(parseFloat(szVal[0]).toFixed(2));
        $(".product-size-outer-height").text(parseFloat(szVal[1]).toFixed(2));
        $(".con-limit-print").show();
      },500);
      
    });
    
    
    $(".variant-picker__option-values [name='option1']").on("change",function(){
      var vl = $(this).val();
      optionSelect(vl);
    });
  
    $(".variant-picker__option-values [name='option3']").on("change",function(){
      var val = $(this).val();
      var mat = val.toLowerCase();
      $(".mat-"+mat).show().siblings("img").hide();
      var matVal = $(".variant-picker__option-values [name='option4']:checked").val();
      var matrVal = $("input[name='option1'][value='Framed Canvas']:checked").length;
  
      var imgURL = '';
      var classAddd = "";
      if(matVal == 'No Mat')
      {
        if(matrVal != 0)
        {
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_canvas[val];
          }
          else
          {
            imgURL = productGalleryFrame.framed_canvas[val];
          }
          
        }
        else
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
          classAddd = "framed_print_no_mat";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_print_no_mat[val];
          }
          else
          {
            imgURL = productGalleryFrame.framed_print_no_mat[val];
          }
        }
        
      }
      else
      {
        if(matrVal != 0)
        {
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_canvas[val];
          }
          else
          {
            imgURL = productGalleryFrame.framed_canvas[val];
          }
          
        }
        else
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
          classAddd = "framed_print_mat";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_print_mat[val];
          }
          else
          {
            imgURL = productGalleryFrame.framed_print_mat[val];
          }
          
        }
        
      }
  
      updateFrame(imgURL,classAddd);
    });
  
    $(".variant-picker__option-values [name='option4']").on("change",function(){
      var vl = $(this).val();
  
      var matVal = vl;
      var frmeVal = $(".variant-picker__option-values [name='option3']:checked").val();
      var imgURL = '';
      if(matVal == 'No Mat')
      {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
        classAddd = "framed_print_no_mat";
        if(isVertical == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
        }
        
      }
      else
      {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
        classAddd = "framed_print_mat";
        if(isVertical == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_mat[frmeVal];
        }
        
      }
      
      updateFrame(imgURL,classAddd);
    });
  }
}

function optionSelect(vl){
  var vl = vl.toLowerCase();
  var imgURL = '';
  var classAddd = '';
  var isVerticl = $("product-gallery").attr("data-vertical");
  
  if(vl == 'framed print')
  {
    $(".variant-picker__option:nth-child(3)").show();
    var selctvl = ($("[name='option3']:checked").val()).toLowerCase();
    if(selctvl == 'no frame')
    {
      $("[name='option3'][value='White']").trigger("click");
    }
    
    var frmeVal = $(".variant-picker__option-values [name='option3']:checked").val();

    $("[name='option3'][value='Walnut']").next("label").show();
    
    $(".variant-picker__option:nth-child(5)").show();
    $(".variant-picker__option:nth-child(5)").find("input").removeAttr("disabled");
    $(".mat").removeAttr("disabled");
    $(".frame").removeAttr("disabled");

     $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");

     $(".header-gallery-img .gallery-img").removeClass("framed_canvas");

     var matVal = $(".variant-picker__option-values [name='option4']:checked").val();

     if(matVal == 'No Mat')
     {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
        classAddd = "framed_print_no_mat";
        if(isVerticl == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
        }
        
     }
     else
     {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
        classAddd = "framed_print_mat";
        if(isVerticl == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_mat[frmeVal];
        }
        
     }
  }
  else if(vl == 'framed canvas')
  {
    $(".variant-picker__option:nth-child(3)").show();
    var selctvl = ($("[name='option3']:checked").val()).toLowerCase();
    if(selctvl == 'no frame')
    {
      $("[name='option3'][value='White']").trigger("click");
    }
    var frmeVal = $(".variant-picker__option-values [name='option3']:checked").val();
    $(".variant-picker__option:nth-child(5)").hide();
    $(".variant-picker__option:nth-child(5)").find("input").attr("disabled","disabled");
    $(".mat").attr("disabled","disabled");
    $(".frame").removeAttr("disabled");

    $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
    $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
    classAddd = "framed_canvas";
    if(isVerticl == 'true')
    {
      imgURL = productGalleryFrameVt.framed_canvas[frmeVal];
    }
    else
    {
      imgURL = productGalleryFrame.framed_canvas[frmeVal];
    }
    $("[name='option3'][value='Walnut']").next("label").hide();
  }
  else
  {
    $("[name='option3'][value='No Frame']").trigger("click");
    $(".variant-picker__option:nth-child(3)").hide();
    $(".variant-picker__option:nth-child(5)").hide();
    $(".variant-picker__option:nth-child(5)").find("input").attr("disabled","disabled");
    $(".mat").attr("disabled","disabled");
    $(".frame").attr("disabled","disabled");

    $("[name='option3'][value='Walnut']").next("label").show();

    $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
    $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
    $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");
    $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat").removeClass("framed_canvas");
  }

  console.log(classAddd);
  updateFrame(imgURL,classAddd);
}

 // window.addEventListener("load",function() { 
if($("sale-price").length != 0)
{
    var targetNode = document.querySelector('[data-block-type="price"] sale-price');

    var config = { attributes: true, childList: true };

    var callback = function(mutationsList) {
        for(var mutation of mutationsList) {
            if (mutation.type == 'childList') {
              console.log('A child node has been added or removed.');
              var prc = ($("[data-block-type='price'] sale-price").text()).replace("Sale price","");
              $(".mobile-header-price").text(prc);
            }
            else if (mutation.type == 'attributes') {
                console.log('The ' + mutation.attributeName + ' attribute was modified.');
            }
        }
    };

    var observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
}
    

    // $('.price-item').on('DOMSubtreeModified', function(){
    //   var prc = $(".price-item").text();
    //   $(".mobile-header-price").text(prc);
    // });


   const optInit = setInterval(opitonInit, 1000);

// Scroll to print image
  
   var indx = $("product-gallery scroll-carousel").find("img[alt='Print Image']").first().parents(".product-gallery__media").index();
   indx = parseInt(indx) + 1;
   if($('carousel-navigation button:nth-child('+indx+')').attr("aria-current") != "true")
   {
     $("carousel-navigation button:nth-child("+indx+")").click();
     $(".mobile-header-gallery .gallery-img:nth-child("+indx+")").addClass("active").siblings(".gallery-img").removeClass("active");
     
   }

  $("carousel-navigation button").on("click",function(){
    var indx = $(this).index();
    indx = parseInt(indx) + 1;
    $(".mobile-header-gallery .gallery-img:nth-child("+indx+")").addClass("active").siblings(".gallery-img").removeClass("active");
  });

// Scroll to print image  
  
   
   
   function opitonInit(){
     if($("#infiniteoptions-container").is("[form]") == true)
     {
       clearInterval(optInit);
    
         $("#infiniteoptions-container input:checked").each(function(){
           var val = $(this).val();
           var selectedOpt = "<span class='selected-opt'> : "+val+"</span>";
           $(this).parents("[role='group']").find(".spb-label-tooltip label").append(selectedOpt);
         }); 

         $(".square-swatches:not([disabled])").each(function(){
          var size = $(this).attr("aria-labelledby");
          if(size.includes("Size"))
          {
            var val = $(this).find("input:checked").val();
            if($(".framed_print_no_mat").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_print_no_mat[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_print_no_mat[val];
              }
            }
            else if($(".framed_print_mat").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_print_mat[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_print_mat[val];
              }
            }
            else if($(".framed_canvas").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_canvas[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_canvas[val];
              }
            }
            else
            {
              
            }
            val = val.split("x");
            $(".product-size-outer-width").text(parseFloat(val[0]).toFixed(2));
            $(".product-size-outer-height").text(parseFloat(val[1]).toFixed(2));
            $(".con-limit-print").show();
          }
        });

       var _this = $(".square-swatches").first().find("input:checked");
       
       optInt(_this);
     }
     
   }

   
   
    $(document).on("change","#infiniteoptions-container input",function(){
      var val = $(this).val();
      var label = $(this).parents("[role='group']").find(".spb-label-tooltip label").html();
      $(this).parents("[role='group']").find(".spb-label-tooltip .selected-opt").text(" : "+val);
      var classAddd = '';
      if($(this).parents("[role='group']").hasClass("square-swatches"))
      {
        setTimeout(function(){
          var imgURL = '';
          var frmeVal = $(".rounded-swatch:not([disabled])").find("input:checked").val();
          if(val == "Framed Print")
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");

            $(".header-gallery-img .gallery-img").removeClass("framed_canvas");
            
            var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
            
            if(matVal == 'No Mat')
            {
              $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
              $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
              classAddd = "framed_print_no_mat";
              if(isVertical == 'true')
              {
                imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
              }
              else
              {
                imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
              }
              
            }
            else
            {
              $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
              $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
              classAddd = "framed_print_mat";
              if(isVertical == 'true')
              {
                imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
              }
              else
              {
                imgURL = productGalleryFrame.framed_print_mat[frmeVal];
              }
              
            }
          }
          else if(val == "Framed Canvas")
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
            classAddd = "framed_canvas";
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_canvas[frmeVal];
            }
            else
            {
              imgURL = productGalleryFrame.framed_canvas[frmeVal];
            }
            
          }
          else if(val == "Print")
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat").removeClass("framed_canvas");
          }
          updateFrame(imgURL,classAddd);
        },500);
        
      }
      if($(this).parents("[role='group']").hasClass("mat-swatch"))
      {
        var _matThis = this;
        var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
        var frmeVal = $(".rounded-swatch:not([disabled])").find("input:checked").val();
        var imgURL = '';
        if(matVal == 'No Mat')
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
          classAddd = "framed_print_no_mat";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
          }
          else
          {
            imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
          }
          
        }
        else
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
          classAddd = "framed_print_mat";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
          }
          else
          {
            imgURL = productGalleryFrame.framed_print_mat[frmeVal];
          }
          
        }

        $(".mat-swatch[disabled]").each(function(){
          if(!$(this).find("input[value='"+matVal+"']").is("checked"))
          {
            $(this).find("input[value='"+matVal+"']").prop("checked",true);
            $(this).find(".selected-opt").text(" : "+matVal);
            $(this).find("input[value='"+matVal+"']").parents("label").siblings("label").find("input").prop("checked",false);
          }
        });

        
        updateFrame(imgURL,classAddd);
        
      }
      if($(this).parents("[role='group']").hasClass("rounded-swatch"))
      {
        setTimeout(function(){
          var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
          var matrVal = $("input[value='Framed Canvas']:checked").length;
          var imgURL = '';
          if(matVal == 'No Mat')
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
            classAddd = "framed_print_no_mat";
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_print_no_mat[val];
            }
            else
            {
              imgURL = productGalleryFrame.framed_print_no_mat[val];
            }
            
          }
          else
          {
            if(matrVal != 0)
            {
              if(isVertical == 'true')
              {
                imgURL = productGalleryFrameVt.framed_canvas[val];
              }
              else
              {
                imgURL = productGalleryFrame.framed_canvas[val];
              }
              
            }
            else
            {
              $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
              $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
              classAddd = "framed_print_mat";
              if(isVertical == 'true')
              {
                imgURL = productGalleryFrameVt.framed_print_mat[val];
              }
              else
              {
                imgURL = productGalleryFrame.framed_print_mat[val];
              }
              
            }
            
          }
          updateFrame(imgURL,classAddd);
        },500);
      }
      setTimeout(function(){
        $(".square-swatches:not([disabled])").each(function(){
          var size = $(this).attr("aria-labelledby");
          if(size.includes("Size"))
          {
            var sVal = $(this).find("input:checked").val();
            var val = $(this).find("input:checked").val();
            if($(".framed_print_no_mat").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_print_no_mat[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_print_no_mat[val];
              }
            }
            else if($(".framed_print_mat").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_print_mat[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_print_mat[val];
              }
            }
            else if($(".framed_canvas").length != 0)
            {
              if(isVertical == 'true')
              {
                val = themeVariables.strings.product_total_vsize.framed_canvas[val];
              }
              else
              {
                val = themeVariables.strings.product_total_size.framed_canvas[val];
              }
            }
            else
            {
              
            }
            val = val.split("x");
            $(".product-size-outer-width").text(parseFloat(val[0]).toFixed(2));
            $(".product-size-outer-height").text(parseFloat(val[1]).toFixed(2));
             
            
              // $(".square-swatches[disabled]").each(function(){
              //   if(!$(this).find("input[value='"+sVal+"']").is("checked"))
              //   {
              //       $(this).find("input[value='"+sVal+"']").prop("checked",true);
              //       $(this).find(".selected-opt").text(" : "+sVal);
              //       $(this).find("input[value='"+sVal+"']").parents("label").siblings("label").find("input").prop("checked",false);

              //   }
              // });
          }
        });

        
        
      },500);
      
    });


  function optInt(_this)
  {
    var val = _this.val();
    var label = _this.parents("[role='group']").find(".spb-label-tooltip label").html();
    _this.parents("[role='group']").find(".spb-label-tooltip .selected-opt").text(" : "+val);
    var classAddd = '';
    if(_this.parents("[role='group']").hasClass("square-swatches"))
    {
      setTimeout(function(){
        var imgURL = '';
        var frmeVal = $(".rounded-swatch:not([disabled])").find("input:checked").val();
        if(val == "Framed Print")
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");

          $(".header-gallery-img .gallery-img").removeClass("framed_canvas");
          
          var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
          
          if(matVal == 'No Mat')
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
            classAddd = "framed_print_no_mat";
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
            }
            else
            {
              imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
            }
            
          }
          else
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
            classAddd = "framed_print_mat";
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
            }
            else
            {
              imgURL = productGalleryFrame.framed_print_mat[frmeVal];
            }
            
          }
        }
        else if(val == "Framed Canvas")
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat");
          classAddd = "framed_canvas";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_canvas[frmeVal];
          }
          else
          {
            imgURL = productGalleryFrame.framed_canvas[frmeVal];
          }
          
        }
        else if(val == "Print")
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_canvas");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_mat").removeClass("framed_print_no_mat").removeClass("framed_canvas");
        }
        updateFrame(imgURL,classAddd);
      },500);
      
    }
    if(_this.parents("[role='group']").hasClass("mat-swatch"))
    {
      var _matThis = _this;
      var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
      var frmeVal = $(".rounded-swatch:not([disabled])").find("input:checked").val();
      var imgURL = '';
      if(matVal == 'No Mat')
      {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
        classAddd = "framed_print_no_mat";
        if(isVertical == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_no_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_no_mat[frmeVal];
        }
        
      }
      else
      {
        $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
        $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
        classAddd = "framed_print_mat";
        if(isVertical == 'true')
        {
          imgURL = productGalleryFrameVt.framed_print_mat[frmeVal];
        }
        else
        {
          imgURL = productGalleryFrame.framed_print_mat[frmeVal];
        }
        
      }

      $(".mat-swatch[disabled]").each(function(){
        if(!$(this).find("input[value='"+matVal+"']").is("checked"))
        {
          $(this).find("input[value='"+matVal+"']").prop("checked",true);
          $(this).find("input[value='"+matVal+"']").parents("label").siblings("label").find("input").prop("checked",false);
        }
      });

      
      updateFrame(imgURL,classAddd);
      
    }
    if(_this.parents("[role='group']").hasClass("rounded-swatch"))
    {
      setTimeout(function(){
        var matVal = $(".mat-swatch:not([disabled])").find("input:checked").val();
        var matrVal = $("input[value='Framed Canvas']:checked").length;
        var imgURL = '';
        if(matVal == 'No Mat')
        {
          $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_mat");
          $(".header-gallery-img .gallery-img").removeClass("framed_print_mat");
          classAddd = "framed_print_no_mat";
          if(isVertical == 'true')
          {
            imgURL = productGalleryFrameVt.framed_print_no_mat[val];
          }
          else
          {
            imgURL = productGalleryFrame.framed_print_no_mat[val];
          }
          
        }
        else
        {
          if(matrVal != 0)
          {
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_canvas[val];
            }
            else
            {
              imgURL = productGalleryFrame.framed_canvas[val];
            }
            
          }
          else
          {
            $("product-gallery scroll-carousel").find(".product-gallery__media").removeClass("framed_print_no_mat");
            $(".header-gallery-img .gallery-img").removeClass("framed_print_no_mat");
            classAddd = "framed_print_mat";
            if(isVertical == 'true')
            {
              imgURL = productGalleryFrameVt.framed_print_mat[val];
            }
            else
            {
              imgURL = productGalleryFrame.framed_print_mat[val];
            }
            
          }
          
        }
        updateFrame(imgURL,classAddd);
      },500);
    }
    setTimeout(function(){
      $(".square-swatches:not([disabled])").each(function(){
        var size = $(this).attr("aria-labelledby");
        if(size.includes("Size"))
        {
          var val = $(this).find("input:checked").val();
          
          if($(".framed_print_no_mat").length != 0)
          {
            if(isVertical == 'true')
            {
              val = themeVariables.strings.product_total_vsize.framed_print_no_mat[val];
            }
            else
            {
              val = themeVariables.strings.product_total_size.framed_print_no_mat[val];
            }
          }
          else if($(".framed_print_mat").length != 0)
          {
            if(isVertical == 'true')
            {
              val = themeVariables.strings.product_total_vsize.framed_print_mat[val];
            }
            else
            {
              val = themeVariables.strings.product_total_size.framed_print_mat[val];
            }
          }
          else if($(".framed_canvas").length != 0)
          {
            if(isVertical == 'true')
            {
              val = themeVariables.strings.product_total_vsize.framed_canvas[val];
            }
            else
            {
              val = themeVariables.strings.product_total_size.framed_canvas[val];
            }
          }
          else
          {
            
          }
          val = val.split("x");
          $(".product-size-outer-width").text(parseFloat(val[0]).toFixed(2));
          $(".product-size-outer-height").text(parseFloat(val[1]).toFixed(2));
        }
      });
    },500);
    
  
  }

   function updateFrame(url,classAdd){
     if(url != '')
     {
       var indx = $("product-gallery scroll-carousel").find("img[alt='Print Image']").first().parents(".product-gallery__media").index();
       $("product-gallery scroll-carousel").each(function(){
         $(this).find("img[alt='Print Image']").parents(".product-gallery__media").addClass(classAdd).css({"--frameUrl":"url('"+url+"')"});
       });
       $(".header-gallery-img .gallery-img").each(function(){
         $(this).find("img[alt='Print Image']").parents(".gallery-img").addClass(classAdd).css({"--frameUrl":"url('"+url+"')"});
       });
       indx = parseInt(indx) + 1;
       if($('carousel-navigation button:nth-child('+indx+')').attr("aria-current") != "true")
       {
         $("carousel-navigation button:nth-child("+indx+")").click();
         console.log(indx);
         $(".mobile-header-gallery .gallery-img:nth-child("+indx+")").addClass("active").siblings(".gallery-img").removeClass("active");
       }
       var maxHeight = parseInt($("scroll-carousel").css("max-height"));

       $("scroll-carousel").css({"max-height":maxHeight+100+"px"});
       
     }
   }
 
 // });

// Zoom Functionality

$('.image-hover-zoom').zoom({
    magnify:1.3
});

if($("product-gallery").length != 0)
{
  $(window).scroll(function() {
    if($(window).width() < 767)
    {
      var top_of_element = $("product-gallery").offset().top;
      if( $("product-gallery").attr("data-vertical") == "true")
      {
        var bottom_of_element = $("product-gallery").offset().top + $("product-gallery").outerHeight() - 200;
      }
      else
      {
        var bottom_of_element = $("product-gallery").offset().top + $("product-gallery").outerHeight();
      }
      
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop() + 120;
  
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
          // the element is visible, do something
        $(".product-mobile-header-gallery").removeClass("active");
      } else {
          // the element is not visible, do something else
        $(".product-mobile-header-gallery").addClass("active");
      }
    }
  });
}


$(".mobile-product-atc").on("click",function(e){
  e.preventDefault();
  // window.Shoppad.apps.infiniteoptions.priceMod.addToCart(e,'',window.Shoppad.apps.infiniteoptions.priceMod.getVariantSubmissions());
  $(".main-product-form").find("buy-buttons.buy-buttons button.button").trigger("click");
});

// $(document).on("click",".bundle-remove",function(e){
//   e.preventDefault();
//   e.stopPropagation();
//   var url = $(this).attr("href");
//   let sections = [];
//   document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sections } }));
//   $.ajax({
//     type: 'POST',
//     url: url+'&sections='+sections.join(","),
//     dataType: 'json',
//     success: function(data) {
//      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
//         bubbles: true,
//         detail: {
//           baseEvent: "line-item:change",
//           cart: data
//         }
//       }));
//     },
//     error:function(data){
//       console.log(data.responseJSON);
//     }
//   });
// });

// $(document).on("click","line-item-quantity2 .quantity-selector__button",function(e){
//   e.preventDefault();
//   e.stopPropagation();
//   var qty = $(this).attr("href").split("quantity=");
//   console.log(qty);
//   var gid = $(this).parents("line-item,.cart-item").attr("data-parent");
//   if(gid != '' && gid != undefined)
//   {
//     document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
//     var id = $("[data-child="+gid+"]").find(".quantity-selector__input").attr("data-line-key");
//     var url = "/cart/update?updates["+id+"]="+qty[1];
//     var id2 = $(this).siblings(".quantity-selector__input").attr("data-line-key");
//     url += "&updates["+id2+"]="+qty[1];
//     // setTimeout(function(){
//       let sections = [];
//       document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sections } }));
//       $.ajax({
//         type: 'POST',
//         url: url+'&sections='+sections.join(","),
//         dataType: 'json',
//         async:true,
//         success: function(data) {
//          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
//             bubbles: true,
//             detail: {
//               baseEvent: "line-item:change",
//               cart: data
//             }
//           }));
//           document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
//         },
//         error:function(data){
//           console.log(data.responseJSON);
//         }
//       });
//     // },1000);
    
//   }
// });

// $(document).on("click","line-item-quantity1 .quantity-selector__button",function(e){
//   e.preventDefault();
//   e.stopPropagation();
//   var qty = $(this).attr("href").split("quantity=");
//   var gid = $(this).parents("line-item,.cart-item").attr("data-parent");
//   if(gid != '' && gid != undefined)
//   {
//     document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
//     var id = $("[data-child="+gid+"]").find(".quantity-selector__input").attr("data-line-key");
//     var url = "/cart/update?updates["+id+"]="+qty[1];
//     if($(".cart-item").length != 0)
//     {
//       var id2 = $(this).siblings(".quantity-selector__input").attr("data-line-key");
//       url += "&updates["+id2+"]="+qty[1];
//       let csections = [];
//       document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: csections } }));
//       $.ajax({
//         type: 'POST',
//         url: url+'&sections='+csections.join(","),
//         dataType: 'json',
//         async:false,
//         success: function(data) {
//          location.reload();
//          // document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
//          //    bubbles: true,
//          //    detail: {
//          //      baseEvent: "line-item:change",
//          //      cart: data
//          //    }
//          //  }));
//         },
//         error:function(data){
//           console.log(data.responseJSON);
//         }
//       });
//     }
    
//   }
//   else
//   {
//     window.location.href = $(this).attr("href");
//   }
// });

// $(".line-item").each(function(){
//   var hasChild = $(this).attr("data-child");
//   if(hasChild != '')
//   {
//     console.log(hasChild);
//     if($(".line-item[data-parent="+hasChild+"]").length == 0)
//     {
//       console.log("hasChild");
//       var url = $(".line-item[data-child="+hasChild+"] line-item-quantity").find("a.link").attr("href");
//       console.log(url);
//       let hsections = [];
//       document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: hsections } }));
//       $.ajax({
//         type: 'POST',
//         url: url+'&sections='+hsections.join(","),
//         dataType: 'json',
//         async:true,
//         success: function(data) {
//          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
//             bubbles: true,
//             detail: {
//               baseEvent: "line-item:change",
//               cart: data
//             }
//           }));
//           document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
//         },
//         error:function(data){
//           console.log(data.responseJSON);
//         }
//       });
//     }
//   }
  
// });